import { ActionTypeList } from '../constants/index'

const initialState = {
    loading: false,
    sessionId: '',
    error: ''
};

export const stripeCheckout = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypeList.CREATE_STRIPE_CHECKOUT_SESSION_SUCCESS:
            return {
                loading: false,
                sessionId: action.payload.sessionId
            };
        case ActionTypeList.CREATE_STRIPE_CHECKOUT_SESSION_REQUEST:
            return {
                loading: true,
                error: action.payload
            };
        default:
            return state;
    }
}
